import { RectConfig } from "konva/lib/shapes/Rect";
import { baseLight, basePrimary, lineExtra } from "./graph-colors";
import { TNodeTypes } from "../models/graph-kn.cm-api-models";

export const Contract_RECT_MODEL:RectConfig = {
    width: 300,
    height: 100,
    cornerRadius: 20,
    opacity: 1,
    strokeWidth:1,
    //stroke:basePrimary,
    fill:baseLight,
    shadowColor: '#e6e6e6',
    shadowBlur: 10,
    shadowOffset: { x: 1, y: 3 },
    shadowOpacity: 1
} as const;

export const BP_STATUS_RECT_MODEL:RectConfig = {
    width: 240,
    height: 110,
    cornerRadius: 10,
    opacity: 1,
    strokeWidth:1,
    stroke:baseLight,
    fill:baseLight
} as const;
export const TASK_STEP_RECT_MODEL:RectConfig = {
    width: 280,
    height: 125,
    cornerRadius: 10,
    opacity: 1,
    strokeWidth:1,
    stroke:lineExtra,
    fill:baseLight
    //shadowColor: '#e6e6e6',
    //shadowBlur: 10,
    //shadowOffset: { x: 1, y: 3 },
    //shadowOpacity: 1
} as const;
export const BP_GROUP_RECT_MODEL:RectConfig = {
    cornerRadius: 15,
    opacity: 1,
    strokeWidth:2,
    stroke:lineExtra,
    fill:'transparent'
} as const;
export const CHILD_BP_STATUS_RECT_MODEL:RectConfig = {
    width: 240,
    height: 110,
    cornerRadius: 10,
    opacity: 1,
    strokeWidth:1,
    stroke:baseLight,
    fill:baseLight
} as const;

type TRectModels = typeof Contract_RECT_MODEL| typeof BP_STATUS_RECT_MODEL | typeof BP_GROUP_RECT_MODEL
export const RectModelsMap:Map<TNodeTypes,TRectModels> = new Map([
    ['BPStatus',BP_STATUS_RECT_MODEL],
    ['TaskStep',TASK_STEP_RECT_MODEL],
    ['parentBP',BP_GROUP_RECT_MODEL],
    ['childBPStatus',CHILD_BP_STATUS_RECT_MODEL],
    ['contractStep',Contract_RECT_MODEL],
    ['subContractStep',Contract_RECT_MODEL, ],
])